<template>
  <div>
    <v-row>
      <v-col cols="3" class="pl-4">
        <RevenueAndProfitChartFilter v-model="filterParams" @get-search="submitSearch"/>
      </v-col>

      <v-col cols="6">
        <RevenueAndProfitStackedChart
          v-if="filterParams.select_filter_type"
          :filter-params="filterParams"
          class="revenue-bar"
        />
        <RevenueAndProfitStackedPeriodChart
          v-else
          :filter-params="filterParams"
          class="revenue-bar"
        />
      </v-col>

      <v-col cols="3" class="p-0">
        <RevenueAndProfitPieChartContainer :filter-params="filterParams" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <v-card>
          <ActualRevenueBarChart :filter-params="filterParams" />
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card>
          <ActualProfitBarChart :filter-params="filterParams" />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RevenueAndProfitStackedChart from '@/components/dashboard/RevenueAndProfitStackedChart'
import RevenueAndProfitPieChartContainer from '@/components/dashboard/RevenueAndProfitPieChartContainer'
import RevenueAndProfitChartFilter from '@/components/dashboard/RevenueAndProfitChartFilter'
import RevenueAndProfitStackedPeriodChart from '@/components/dashboard/RevenueAndProfitStackedPeriodChart'
import ActualRevenueBarChart from '@/components/dashboard/RevenueAndProfitBarChart/ActualRevenueBarChart'
import ActualProfitBarChart from '@/components/dashboard/RevenueAndProfitBarChart/ActualProfitBarChart'

export default {
  name: 'RevenueAndProfit',

  components: {
    RevenueAndProfitChartFilter,
    RevenueAndProfitStackedChart,
    RevenueAndProfitPieChartContainer,
    RevenueAndProfitStackedPeriodChart,
    ActualRevenueBarChart,
    ActualProfitBarChart
  },

  data () {
    return {
      filterParams: {}
    }
  },

  methods: {
    submitSearch (search) {
      if (search) {
        this.filterParams = {
          ...this.filterParams, search
        }
      }
    }
  }
}
</script>
